export const defaultTableCells = [
  {
    label: 'First Name',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'Last Name',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'Email',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'Phone Number',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'DOB',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'Created At',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'Created By',
    display: true,
    width: 'auto',
    align: 'text-left'
  },
  {
    label: 'Error',
    display: true,
    width: '20%',
    align: 'text-left'
  },
  {
    label: 'Action',
    display: true,
    width: '100px',
    align: 'text-center'
  }
];
